import { useSelector } from 'react-redux';

// Config
import recommendationsState, { getRecommendationElementIdSelector } from './Recommendations.state';

// Components
import Container from '@components/container';
import ESIInclude from '@components/esi-include/ESIInclude';

const Recommendations = () => {
  const src = useSelector(recommendationsState);
  const id = getRecommendationElementIdSelector();

  return (
    <Container background="white">
      <ESIInclude id={id} src={src} />
    </Container>
  );
};

export default Recommendations;
